<template>
  <div class="nav-mobile__bottom">
    <div class="nav-mobile__bottom-left">
      <router-link :to="{name: 'members'}">
        <i @click="clearMembersStore" id="menu-mobile-members" class="icon-demo icon-n-group-users"></i>
        <span class="nav-mobile__bottom-label">{{ trans.get('top_bar.members') }}</span>
      </router-link>
    </div>
    <div class="nav-mobile__bottom-center">
      <router-link :to="{name: 'match_game'}">
        <i id="menu-mobile-match-game" class="icon-demo icon-viluu-padlock-cards"></i>
        <span class="nav-mobile__bottom-label">{{ trans.get('top_bar.match_game') }}</span>
      </router-link>
    </div>
    <div class="nav-mobile__bottom-right">
      <router-link :to="{name: 'chat'}" :class="{'active': $router.name === 'chat'}">
        <i id="menu-mobile-chat" class="icon-demo icon-n-chats"></i>
        <UnreadMessagesComponent></UnreadMessagesComponent>
        <span class="nav-mobile__bottom-label">{{ trans.get('top_bar.messages') }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>

import ClearMembersStore from '../../../front/views/elements/ClearMembersStore';
import UnreadMessagesComponent from '../../components/Chat/UnreadMessagesComponent';

export default {
  name: 'BottomMobileMenu',
  components: { UnreadMessagesComponent },
  mixins: [ClearMembersStore],
  data() {
    return {};
  },
  methods: {},
  mounted() {
  }
};
</script>
